import React, { useEffect, useState } from "react";
import { api } from "../features/apiServices/apiClient";
import "./css/SalaoPage.css";
import { useNavigate } from "react-router-dom";
import ModalMesaClick from "../components/ModalMesaClick";
import safeJSON from "../components/safeJSON";
import { gerarPayloadPix } from "../utils/pixUtils";



const SalaoPage = () => {
    const navigate = useNavigate();
    const token = localStorage.getItem("accessToken");
    const tenant = safeJSON("tenant");
    const user = safeJSON("user");
    const activeRestaurant = safeJSON("activeRestaurant");
    
    const [comandaSelecionada, setComandaSelecionada] = useState(null);
    const [mesaSelecionada, setMesaSelecionada] = useState(null);
    const [showModalComanda, setShowModalComanda] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [modalMessage, setModalMessage] = useState("");

    // --- Adicionar Pedido ---
    const [showMenuPanel, setShowMenuPanel] = useState(false);
    const [itensMenu, setItensMenu] = useState([]);
    const [categoriasMenu, setCategoriasMenu] = useState([]);
    const [categoriaSelecionada, setCategoriaSelecionada] = useState(null);

    const [itemSelecionado, setItemSelecionado] = useState(null);
    const [qtd, setQtd] = useState(1);
    const [obs, setObs] = useState("");

    const [mesas, setMesas] = useState([]);
    const [comandasSolicitadas, setComandasSolicitadas] = useState([]);
    const [chamadasGarcon, setChamadasGarcon] = useState([]);
    const [showContasModal, setShowContasModal] = useState(false);
    const [showGarconModal, setShowGarconModal] = useState(false);
    const [imprimindo, setImprimindo] = useState(null);
    const [dispensando, setDispensando] = useState(null);
    const [printerConfig, setPrinterConfig] = useState(null);
    const [kpis, setKpis] = useState({
        total: 0,
        ocupadas: 0,
        disponiveis: 0,
        comandas: 0,
        pendentes: 0,
    });

    const Headers = {
        Authorization: `Bearer ${token}`,
        "x-tenant-slug": tenant.slug,
    }

    // ================================
    // BUSCAR MESAS DO RESTAURANTE
    // ================================
    const loadMesas = async () => {
        try {
            // 1. Buscar mesas
            const mesasResponse = await api.get(`/tables?restaurant_id=${activeRestaurant.id}`, {
                headers: Headers
            });

            let mesasData = mesasResponse.data || [];

            mesasData = mesasData.filter(m => !m.name.toLowerCase().startsWith("delivery"));


            // Ordenar mesas pelo número
            mesasData = mesasData.sort((a, b) => {
                const numA = parseInt(a.name.match(/\d+/)?.[0] ?? 0);
                const numB = parseInt(b.name.match(/\d+/)?.[0] ?? 0);
                return numA - numB;
            });


            // 2. Buscar comandas abertas do restaurante
            const comandasResponse = await api.get(
                `/comandas/restaurant/${activeRestaurant.id}`,
                {
                    headers: Headers
                }
            );

            let comandasData = comandasResponse.data || [];

            comandasData = comandasData.filter(
                (c) =>
                    c.status === "aberta" &&
                    !c.mesa.toLowerCase().startsWith("delivery")
            );


            // 3) PEDIDOS JÁ VÊM INCLUÍDOS NA RESPOSTA DAS COMANDAS (elimina N+1 queries)



            // 4. FAZER O MERGE: vincular comanda à mesa pelo NOME
            const mesasComComandas = mesasData.map((mesa) => {
                const comandaDaMesa = comandasData.find(
                    //(c) => c.mesa === mesa.name && c.status === "aberta"
                    (c) => c.mesa === mesa.name
                );

                return {
                    ...mesa,
                    comanda_aberta: comandaDaMesa
                        ? {
                            ...comandaDaMesa,
                            pedidos: comandaDaMesa.pedidos || [], // <--- GARANTE QUE É ARRAY
                        }
                        : null,
                };
            });

            // 5. Atualizar KPIs
            const ocupadas = mesasData.filter((m) => m.status === "occupied").length;
            const disponiveis = mesasData.length - ocupadas;
            const comandasAbertas = comandasData.length;

            const pendentes = comandasData.reduce((acc, comanda) => {
                const pend = comanda.pedidos?.filter((p) => p.status !== "pronto").length || 0;
                return acc + pend;
            }, 0);

            setKpis({
                total: mesasData.length,
                ocupadas,
                disponiveis,
                comandas: comandasAbertas,
                pendentes,
            });

            // 6. Atualiza estado final
            setMesas(mesasComComandas);

            // 7. Contas solicitadas e chamadas de garçom
            const todasComandas = comandasResponse.data || [];
            setComandasSolicitadas(todasComandas.filter(c => c.status === 'solicitada'));

            const garconRes = await api.get(`/garcon/chamadas/${activeRestaurant.id}`, { headers: Headers });
            setChamadasGarcon(garconRes.data || []);

        } catch (error) {
            console.error("Erro ao carregar mesas + comandas:", error);
        }
    };

    const visualizarComanda = (mesa) => {
        if (!mesa.comanda_aberta) return;
        setComandaSelecionada(mesa.comanda_aberta);
        setMesaSelecionada(mesa);

        setShowModalComanda(true);
    };

    const abrirComanda = async (mesa) => {
        try {
            await api.post(
                `/comanda`,
                {
                    table_id: mesa.id,
                    restaurant_id: activeRestaurant.id,
                    opened_by: user.id
                },
                { headers: Headers }
            );

            setModalMessage(`Comanda aberta para a ${mesa.name}!`);
            setModalOpen(true);

        } catch (err) {
            console.error("Erro ao abrir comanda:", err);
            setModalMessage(`Erro ao abrir comanda. ${err}`);
            setModalOpen(true);
        }
    };

    const fecharComanda = async (comanda) => {
        try {

            await api.patch(
                `/comanda/${comanda.comanda_id}/fechar`,
                {
                    closed_by: user.id
                },
                { headers: Headers }
            );

            setModalMessage(`Comanda da ${comanda.mesa} fechada com sucesso!`);
            setShowModalComanda(false);
            setModalOpen(true);

        } catch (err) {
            console.error("Erro ao fechar comanda:", err);
            setModalMessage(`Erro ao fechar comanda. ${err}`);
            setShowModalComanda(false);
            setModalOpen(true);
        }
    };





    const adicionarPedido = async () => {
        try {
            const resp = await api.get(`/menu/restaurant_id/${activeRestaurant.id}`, {
                headers: Headers
            });

            const cats = [...new Set(resp.data.map(i => i.categoria))];
            setItensMenu(resp.data);
            setCategoriasMenu(cats);
            if (cats.length > 0) setCategoriaSelecionada(cats[0]);
            setShowMenuPanel(true);

        } catch (err) {
            console.error("Erro ao carregar menu:", err);
            setModalMessage(`Erro ao carregar itens do menu. ${err}`)
            setModalOpen(true);
        }
    };

    const confirmarAddItem = async () => {
        try {
            await api.post("/pedido", {
                comanda_id: comandaSelecionada.comanda_id,
                restaurant_id: activeRestaurant.id,
                mesa_id: mesaSelecionada.id,
                itens: [
                    {
                        menu_id: itemSelecionado.id,
                        quantidade: qtd,
                        notes: obs || ""
                    }
                ]
            }, {
                headers: Headers
            });

            // Atualiza pedidos da comanda sem fechar a modal
            const pedidosResp = await api.get(
                `/pedido/comanda/${comandaSelecionada.comanda_id}`,
                { headers: Headers }
            );
            setComandaSelecionada(prev => ({ ...prev, pedidos: pedidosResp.data || [] }));

            setItemSelecionado(null);
            setQtd(1);
            setObs("");
            setShowMenuPanel(false);

        } catch (err) {
            console.error(err);
            setItemSelecionado(null);
            setModalMessage(`Erro ao adicionar item. ${err}`);
            setModalOpen(true);
        }
    };





    useEffect(() => {
        if (!localStorage.getItem("accessToken")) return;

        api.get("/printer").then(res => {
            if (res.data.length > 0) setPrinterConfig(res.data[0]);
        }).catch(() => {});

        loadMesas();

        const interval = setInterval(() => {
            loadMesas();
        }, 3000);

        return () => clearInterval(interval);

    }, []);

    const imprimirNoBrowser = async (comanda) => {
        const pedidos = comanda.pedidos || [];
        const total = pedidos.reduce((acc, p) => acc + p.quantidade * Number(p.Menu?.preco || 0), 0);
        const agora = new Date().toLocaleString("pt-BR");

        let pixPayload = "";
        const cnpj = activeRestaurant?.cnpj;
        if (cnpj) {
            const txid = 'RST' + String(comanda.comanda_id).replace(/[^a-zA-Z0-9]/g, '').slice(-8);
            pixPayload = gerarPayloadPix({
                chave: cnpj,
                nome: activeRestaurant.nome || 'Restaurante',
                cidade: activeRestaurant?.address?.city || 'Brasil',
                valor: total,
                txid,
            });
        }

        const pixHtml = pixPayload ? `
            <hr/>
            <p style="text-align:center;margin:4px 0">Pague com Pix</p>
            <div id="qrpix" style="display:flex;justify-content:center;margin:6px 0"></div>
            <p style="text-align:center;font-size:10px">Abra seu banco · Pix · Ler QR Code</p>
            <script src="https://cdnjs.cloudflare.com/ajax/libs/qrcodejs/1.0.0/qrcode.min.js"><\/script>
            <script>new QRCode(document.getElementById('qrpix'),{text:'${pixPayload}',width:120,height:120,correctLevel:QRCode.CorrectLevel.M});<\/script>
        ` : "";

        const linhas = pedidos.map(p => {
            const nome = p.Menu?.nome || "Item";
            const preco = Number(p.Menu?.preco || 0);
            const subtotal = preco * p.quantidade;
            return `<tr>
                <td>${p.quantidade}x ${nome}</td>
                <td style="text-align:right">R$ ${subtotal.toFixed(2)}</td>
            </tr>`;
        }).join("");

        const html = `
            <html><head><title>Comanda</title>
            <style>
                * { box-sizing: border-box; }
                body { font-family: monospace; font-size: 12px; margin: 0; padding: 8px; }
                h2, p { text-align: center; margin: 3px 0; }
                hr { border: none; border-top: 1px dashed #000; margin: 4px 0; }
                table { width: 100%; border-collapse: collapse; }
                td { padding: 2px 0; word-break: break-word; }
                td:last-child { text-align: right; white-space: nowrap; padding-left: 8px; }
                .total { font-size: 14px; font-weight: bold; text-align: right; margin-top: 6px; }
                @media print { body { margin: 0; padding: 4px; } @page { margin: 4mm; } }
            </style></head>
            <body>
                <h2>${activeRestaurant.nome || "Restaurante"}</h2>
                <p>${agora}</p>
                <hr/>
                <p><strong>${comanda.mesa}</strong> — Comanda #${String(comanda.comanda_id).slice(-5)}</p>
                <hr/>
                <table>${linhas}</table>
                <hr/>
                <p class="total">Total: R$ ${total.toFixed(2)}</p>
                ${pixHtml}
                <br/><br/>
            </body></html>`;

        const iframe = document.createElement("iframe");
        iframe.style.cssText = "position:fixed;top:-9999px;left:-9999px;width:0;height:0;border:none;";
        document.body.appendChild(iframe);
        iframe.contentDocument.open();
        iframe.contentDocument.write(html);
        iframe.contentDocument.close();
        setTimeout(() => {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
            setTimeout(() => document.body.removeChild(iframe), 1000);
        }, 800);
    };

    const imprimirViaIP = async (comanda) => {
        await api.post('/imprimir/comanda', {
            comanda_id: comanda.comanda_id,
            restaurant_id: activeRestaurant.id
        });
    };

    const handleImprimir = async (comanda) => {
        setImprimindo(comanda.comanda_id);
        try {
            if (printerConfig?.type === "ip") {
                await imprimirViaIP(comanda);
            } else {
                await imprimirNoBrowser(comanda);
            }
        } catch (err) {
            console.error("Erro ao imprimir:", err);
        } finally {
            setImprimindo(null);
        }
    };

    const handleDispensarGarcon = async (chamada) => {
        setDispensando(chamada.id);
        try {
            await api.patch(`/garcon/dispensar/${chamada.id}`, {}, { headers: Headers });
            setChamadasGarcon(prev => prev.filter(c => c.id !== chamada.id));
        } catch (err) {
            alert('Erro ao marcar como atendido.');
        } finally {
            setDispensando(null);
        }
    };

    const imprimirComanda = async () => {
        try {
            if (printerConfig?.type === "ip") {
                await imprimirViaIP(comandaSelecionada);
            } else {
                await imprimirNoBrowser(comandaSelecionada);
            }
            setModalMessage("Comanda enviada para impressão!");
            setModalOpen(true);
        } catch (err) {
            console.error("Erro ao imprimir comanda:", err);
            setModalMessage(err.response?.data?.error || "Erro ao imprimir comanda.");
            setModalOpen(true);
        }
    };



    return (
        <div className="page-container">

            {/* HEADER */}
            <div className="header">
                <div className="salao-header-left">

                    <img
                        src="/assets/logo-mesaclick.png"
                        alt="MesaClick"
                        className="header-logo"
                        onClick={() => navigate("/home")}
                    />
                    {activeRestaurant && (
                        <span className="mc-rest-badge">
                            <span className="mc-rest-badge-dot" />
                            Salão · {activeRestaurant.nome}
                        </span>
                    )}
                </div>


                <div className="header-notif-sl">
                    <button className="contas-solicitadas-btn" onClick={() => setShowGarconModal(true)} title="Chamadas de garçom">
                        🛎️
                        {chamadasGarcon.length > 0 && <span className="contas-badge">{chamadasGarcon.length}</span>}
                    </button>
                    <button className="contas-solicitadas-btn" onClick={() => setShowContasModal(true)} title="Contas solicitadas">
                        🧾
                        {comandasSolicitadas.length > 0 && <span className="contas-badge">{comandasSolicitadas.length}</span>}
                    </button>
                </div>

                <div className="kpi-container-sl">


                    <div className="kpi-card-sl">
                        <span className="kpi-card-title-sl">Total de mesas</span>
                        <span className="kpi-card-value-sl">{kpis.total}</span>
                    </div>


                    <div className="kpi-card-sl">
                        <span className="kpi-card-title-sl" >Ocupadas</span>
                        <span className="kpi-orange">{kpis.ocupadas}</span>
                    </div>

                    <div className="kpi-card-sl">
                        <span className="kpi-card-title-sl" >Disponíveis</span>
                        <span className="kpi-green">{kpis.disponiveis}</span>
                    </div>

                    <div className="kpi-card-sl">
                        <span className="kpi-card-title-sl" >Comandas abertas</span>
                        <span className="kpi-blue">{kpis.comandas}</span>
                    </div>

                    <div className="kpi-card-sl">
                        <span className="kpi-card-title-sl" >Pedidos pendentes</span>
                        <span className="kpi-red">{kpis.pendentes}</span>
                    </div>
                </div>


            </div>


            {/* LISTA DE MESAS */}
            <div className="mesas-grid">
                {mesas.map((mesa) => (
                    <div
                        key={mesa.id}
                        className={`mesa-card-compact
                            ${mesa.comanda_aberta &&
                                mesa.comanda_aberta.pedidos.some(p => p.status !== "entregue")
                                ? "mesa-alerta"
                                : ""}
                        `}
                        onClick={() => {
                            // 👉 Só abre modal se a mesa tiver comanda aberta
                            if (mesa.comanda_aberta) {
                                visualizarComanda(mesa);
                            }
                        }}
                    >
                        <div className="mesa-nome">{mesa.name}</div>

                        {/* STATUS */}
                        <div className="mesa-status-container">
                            <span
                                className={`status-badge-sl ${mesa.comanda_aberta ? "status-ocupada-sl" : "status-livre-sl"
                                    }`}
                            >
                                {mesa.comanda_aberta ? "Ocupada" : "Disponível"}
                            </span>

                            {/* 👉 SOMENTE quando estiver disponível exibe o botão ABRIR */}
                            {!mesa.comanda_aberta && (
                                <button
                                    className="btn-abrir"
                                    onClick={(e) => {
                                        e.stopPropagation(); // impede abrir modal
                                        abrirComanda(mesa);
                                    }}
                                >
                                    Abrir Comanda
                                </button>
                            )}
                        </div>

                        {/* Pendências quando ocupada */}
                        {mesa.comanda_aberta &&
                            mesa.comanda_aberta.pedidos.some(p => p.status !== "entregue") && (
                                <span className="mesa-badge-pend-sl">
                                    {mesa.comanda_aberta.pedidos.filter(p => p.status !== "entregue").length}
                                    {" "}pendente(s)
                                </span>
                            )}
                    </div>
                ))}
            </div>

            {showModalComanda && (
                <div className="modal-overlay" onClick={() => { setShowModalComanda(false); setShowMenuPanel(false); }}>
                    <div className={`dl-modal-wrapper${showMenuPanel ? " dl-modal-wrapper--expanded" : ""}`} onClick={(e) => e.stopPropagation()}>

                        {/* MODAL DA COMANDA */}
                        <div className="modal-comanda">
                            <h2 className="modal-title">
                                {comandaSelecionada.mesa} — #{comandaSelecionada.comanda_id.slice(-5)}
                            </h2>

                            <h4 className="modal-subtitle">Itens</h4>

                            {comandaSelecionada.pedidos?.length > 0 ? (
                                <div className="modal-items-scroll">
                                    <ul className="modal-items-list">
                                        {comandaSelecionada.pedidos.map((p) => {
                                            const nomeItem = p.Menu?.nome || "Item";
                                            const preco = Number(p.Menu?.preco || 0);
                                            const subtotal = preco * p.quantidade;
                                            return (
                                                <li key={p.id} className="modal-item">
                                                    <div className="item-left">
                                                        <strong>{p.quantidade}x</strong> — {nomeItem}
                                                        <span className="item-status">({p.status})</span>
                                                    </div>
                                                    <div className="item-right">
                                                        <span className="preco-unit">R$ {preco.toFixed(2)}</span>
                                                        <span className="preco-subtotal">R$ {subtotal.toFixed(2)}</span>
                                                    </div>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </div>
                            ) : (
                                <p className="modal-empty">Nenhum item na comanda.</p>
                            )}

                            <div className="modal-total">
                                <span>Total:</span>
                                <strong>
                                    R$ {(comandaSelecionada.pedidos || [])
                                        .reduce((acc, p) => acc + p.quantidade * Number(p.Menu?.preco || 0), 0)
                                        .toFixed(2)}
                                </strong>
                            </div>

                            <button className="modal-btn-pedido" onClick={adicionarPedido}>
                                {showMenuPanel ? "Ocultar Cardápio" : "Adicionar Pedido"}
                            </button>

                            <button className="modal-btn-print" onClick={imprimirComanda}>
                                Imprimir Comanda
                            </button>

                            <button className="modal-btn-close" onClick={() => { setShowModalComanda(false); setShowMenuPanel(false); }}>
                                Fechar Janela
                            </button>

                            <button className="modal-btn-danger" onClick={() => fecharComanda(comandaSelecionada)}>
                                Fechar Comanda
                            </button>
                        </div>

                        {/* PAINEL DO CARDÁPIO (aparece ao lado) */}
                        {showMenuPanel && (
                            <div className="dl-menu-panel">
                                <div className="dl-menu-panel-header">
                                    <h3>Cardápio</h3>
                                    <button className="dl-menu-panel-close" onClick={() => setShowMenuPanel(false)}>✕</button>
                                </div>

                                <div className="dl-menu-cats">
                                    {categoriasMenu.map((cat) => (
                                        <button
                                            key={cat}
                                            className={`dl-cat-btn${categoriaSelecionada === cat ? " active" : ""}`}
                                            onClick={() => setCategoriaSelecionada(cat)}
                                        >
                                            {cat}
                                        </button>
                                    ))}
                                </div>

                                <div className={`dl-menu-items${itemSelecionado ? " dl-menu-items--compact" : ""}`}>
                                    {itensMenu
                                        .filter((i) => i.categoria === categoriaSelecionada)
                                        .map((item) => (
                                            <div
                                                key={item.id}
                                                className={`dl-menu-item-card${itemSelecionado?.id === item.id ? " dl-menu-item-card--selected" : ""}`}
                                                onClick={() => { setItemSelecionado(item); setQtd(1); setObs(""); }}
                                            >
                                                {item.foto ? (
                                                    <img src={`data:image/jpeg;base64,${item.foto}`} className="dl-menu-item-foto" alt={item.nome} />
                                                ) : (
                                                    <div className="dl-menu-item-foto dl-menu-item-foto--placeholder">🍽️</div>
                                                )}
                                                <div className="dl-menu-item-body">
                                                    <span className="dl-menu-item-nome">{item.nome}</span>
                                                    {item.descricao && <span className="dl-menu-item-desc">{item.descricao}</span>}
                                                    <span className="dl-menu-item-preco">R$ {Number(item.preco).toFixed(2)}</span>
                                                </div>
                                                <button
                                                    className="dl-menu-item-add"
                                                    onClick={(e) => { e.stopPropagation(); setItemSelecionado(item); setQtd(1); setObs(""); }}
                                                >
                                                    +
                                                </button>
                                            </div>
                                        ))}
                                </div>

                                {/* Item selecionado — base do painel */}
                                {itemSelecionado && (
                                    <div className="dl-selected-item">
                                        <div className="dl-selected-item-top">
                                            {itemSelecionado.foto ? (
                                                <img src={`data:image/jpeg;base64,${itemSelecionado.foto}`} className="dl-selected-foto" alt={itemSelecionado.nome} />
                                            ) : (
                                                <div className="dl-selected-foto dl-selected-foto--placeholder">🍽️</div>
                                            )}
                                            <div className="dl-selected-info">
                                                <span className="dl-selected-nome">{itemSelecionado.nome}</span>
                                                {itemSelecionado.descricao && <span className="dl-selected-desc">{itemSelecionado.descricao}</span>}
                                                <span className="dl-selected-preco">R$ {Number(itemSelecionado.preco).toFixed(2)}</span>
                                            </div>
                                            <button className="dl-selected-clear" onClick={() => setItemSelecionado(null)}>✕</button>
                                        </div>

                                        <div className="dl-selected-controls">
                                            <div className="dl-selected-qtd">
                                                <button onClick={() => setQtd((q) => Math.max(1, q - 1))}>−</button>
                                                <span>{qtd}</span>
                                                <button onClick={() => setQtd((q) => q + 1)}>+</button>
                                            </div>
                                            <textarea
                                                className="dl-selected-obs"
                                                placeholder="Observação (opcional)"
                                                value={obs}
                                                onChange={(e) => setObs(e.target.value)}
                                                rows={2}
                                            />
                                            <button className="dl-selected-add-btn" onClick={confirmarAddItem}>
                                                Adicionar — R$ {(Number(itemSelecionado.preco) * qtd).toFixed(2)}
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            )}

            {showGarconModal && (
                <div className="contas-modal-overlay" onClick={() => setShowGarconModal(false)}>
                    <div className="contas-modal" onClick={e => e.stopPropagation()}>
                        <div className="contas-modal-header">
                            <h2>🛎️ Chamadas de Garçom</h2>
                            <button className="contas-modal-close" onClick={() => setShowGarconModal(false)}>✕</button>
                        </div>
                        {chamadasGarcon.length === 0 ? (
                            <p className="contas-modal-empty">Nenhuma mesa chamando o garçom.</p>
                        ) : (
                            <div className="contas-modal-list">
                                {chamadasGarcon.map(c => (
                                    <div key={c.id} className="contas-modal-item">
                                        <div className="contas-modal-item-info">
                                            <span className="contas-modal-mesa">Mesa {c.mesa}</span>
                                            <span style={{ fontSize: 12, color: '#9ca3af' }}>
                                                {new Date(c.createdAt).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}
                                            </span>
                                        </div>
                                        <button
                                            className="contas-modal-print-btn"
                                            style={{ background: '#16a34a' }}
                                            disabled={dispensando === c.id}
                                            onClick={() => handleDispensarGarcon(c)}
                                        >
                                            {dispensando === c.id ? '...' : '✔ Atendido'}
                                        </button>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            )}

            {showContasModal && (
                <div className="contas-modal-overlay" onClick={() => setShowContasModal(false)}>
                    <div className="contas-modal" onClick={e => e.stopPropagation()}>
                        <div className="contas-modal-header">
                            <h2>🧾 Contas Solicitadas</h2>
                            <button className="contas-modal-close" onClick={() => setShowContasModal(false)}>✕</button>
                        </div>
                        {comandasSolicitadas.length === 0 ? (
                            <p className="contas-modal-empty">Nenhuma conta solicitada.</p>
                        ) : (
                            <div className="contas-modal-list">
                                {comandasSolicitadas.map(c => (
                                    <div key={c.comanda_id} className="contas-modal-item">
                                        <div className="contas-modal-item-info">
                                            <span className="contas-modal-mesa">Mesa {c.mesa}</span>
                                            <span className="contas-modal-total">R$ {parseFloat(c.valor_total).toFixed(2)}</span>
                                        </div>
                                        <button
                                            className="contas-modal-print-btn"
                                            disabled={imprimindo === c.comanda_id}
                                            onClick={() => handleImprimir(c)}
                                        >
                                            {imprimindo === c.comanda_id ? 'Enviando...' : '🖨️ Imprimir'}
                                        </button>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            )}

            <ModalMesaClick
                open={modalOpen}
                message={modalMessage}
                onClose={() => setModalOpen(false)}
            />


        </div>
    );
};



export default SalaoPage;
